interface AddressFormatMetadata {
  fmt?: string;
}

export interface PostalAddressFormattingInput {
  addressLines: string;
  administrativeArea: string;
  countryCode: string;
  countryName: string;
  locality: string;
  postalCode: string;
}

const ADDRESS_METADATA_BASE_URL = "https://chromium-i18n.appspot.com/ssl-address/data";

export const formatPostalAddress = (
  template: string | undefined,
  values: Record<string, string>,
): string | null => {
  if (!template) return null;

  const formatted = template
    .replace(/%n/g, "\n")
    .replace(/%[A-Z]/g, (token) => values[token.slice(1)] || "")
    .split("\n")
    .map((line) =>
      line
        .replace(/\s{2,}/g, " ")
        .replace(/\s+,/g, ",")
        .replace(/,\s*$/, "")
        .trim(),
    )
    .filter(Boolean);

  return formatted.length ? formatted.join("\n") : null;
};

export const formatPostalAddressForCountry = async ({
  addressLines,
  administrativeArea,
  countryCode,
  countryName,
  locality,
  postalCode,
}: PostalAddressFormattingInput): Promise<string | null> => {
  if (!countryCode) return null;

  try {
    const response = await fetch(`${ADDRESS_METADATA_BASE_URL}/${encodeURIComponent(countryCode)}`);
    if (!response.ok) return null;

    const metadata = (await response.json()) as AddressFormatMetadata;
    const postalAddress = formatPostalAddress(metadata.fmt, {
      N: "",
      O: "",
      A: addressLines,
      D: "",
      C: locality,
      S: administrativeArea,
      Z: postalCode,
      X: "",
    });

    if (!postalAddress) return null;

    return countryName ? `${postalAddress}\n${countryName}` : postalAddress;
  } catch {
    return null;
  }
};
